<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
<!--              <el-form-item label="数值类型">-->
<!--                  <el-input  v-model="queryForm.valueType"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="数值">-->
<!--                  <el-input  v-model="queryForm.value"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="方向">-->
<!--                  <el-input  v-model="queryForm.orientation"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="原来值">-->
<!--                  <el-input  v-model="queryForm.originalValue"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="剩余值">-->
<!--                  <el-input  v-model="queryForm.restValue"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="用户">-->
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <el-form-item label='用户'>
                      <GridSelect
                          style='width: 200px'
                          title='选择用户'
                          labelName='userName'
                          labelValue='id'
                          :value='queryForm.userId'
                          :limit='1'
                          size='small'
                          placeholder='请选择用户'
                          @getValue='getSearchValue'
                          :columns="USER_code"
                          :searchs="USER_search"
                          dataListUrl='/mpp/user/findList'
                          entityBeanName='mppUser'
                          queryEntityUrl='/mpp/user/get'
                      >
                      </GridSelect>
                  </el-form-item>
<!--              </el-form-item>-->
                  <el-form-item label="所属省份" prop="provinceId">
                      <el-select
                          style='width:200px'
                          v-model='queryForm.provinceId'
                          size='small'
                          placeholder='请选择省份'
                      >
                          <el-option
                              v-for='item in provinceIdList'
                              :key='item.id'
                              :label='item.name'
                              :value='item.id'
                          ></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item label="所属城市" prop="cityId">
                      <el-select
                          style='width:200px'
                          v-model='queryForm.cityId'
                          size='small'
                          placeholder='请选择城市'
                      >
                          <el-option
                              v-for='item in cityIdList'
                              :key='item.id'
                              :label='item.name'
                              :value='item.id'
                          ></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item label="所属区县" prop="areaId">
                      <el-select
                          style='width:200px'
                          v-model='queryForm.areaId'
                          size='small'
                          placeholder='请选择区县'
                      >
                          <el-option
                              v-for='item in areaIdList'
                              :key='item.id'
                              :label='item.name'
                              :value='item.id'
                          ></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item
                      label="所属乡镇"
                      prop="streetId"
                      v-if="queryForm.provinceId != 1 && queryForm.provinceId != 2 && queryForm.provinceId != 3 && queryForm.provinceId != 4"
                  >
                      <!--                            <el-input-->
                      <!--                                size="small"-->
                      <!--                                v-model="shopStoreOrgInfo.licenseTownId"-->
                      <!--                            ></el-input>-->
                      <el-select
                          style='width:200px'
                          v-model='queryForm.streetId'
                          size='small'
                          placeholder='请选择乡镇'
                      >
                          <el-option
                              v-for='item in streetIdList'
                              :key='item.id'
                              :label='item.name'
                              :value='item.id'
                          ></el-option>
                      </el-select>
                  </el-form-item>
<!--              <el-form-item label="店铺ID">-->
<!--                  <el-input  v-model="queryForm.shopId"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="门店ID">-->
<!--                  <el-input  v-model="queryForm.storeId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getReportGlobalvalueRecordStoreList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addReportGlobalvalueRecordStore"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editReportGlobalvalueRecordStore(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteReportGlobalvalueRecordStore(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入"xls"或"xlsx"格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshReportGlobalvalueRecordStoreList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="reportGlobalvalueRecordStoreList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="valueType"
        label="数值类型"
        width="180"
      >
          <template slot-scope="scope">
              {{computeGlobalvalueType(scope.row.valueType)}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="value"
        label="数值"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orientation"
        label="方向"
        width="180"
      >
          <template slot-scope="scope">
              {{returnValue(scope.row.orientation)}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="originalValue"
        label="原来值"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="restValue"
        label="剩余值"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope" v-if="scope.row.user">
              <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
              <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
              <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
              <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
          </template>
          <template slot-scope="scope" v-else>
              --
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="storeId"
        label="门店ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkReportGlobalvalueRecordStore(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editReportGlobalvalueRecordStore(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteReportGlobalvalueRecordStore(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="reportGlobalvalueRecordStoreStates[reportGlobalvalueRecordStoreState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="reportGlobalvalueRecordStore"
          ref="reportGlobalvalueRecordStoreForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="数值类型"
            prop="valueType"
          >
            <el-input
              size="small"
              style='width: 200px'
              v-model="reportGlobalvalueRecordStore.valueType"
              :disabled="reportGlobalvalueRecordStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="数值"
            prop="value"
          >
            <el-input
              size="small"
              style='width: 200px'
              v-model="reportGlobalvalueRecordStore.value"
              :disabled="reportGlobalvalueRecordStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="方向"
            prop="orientation"
          >
            <el-input
              size="small"
              style='width: 200px'
              v-model="reportGlobalvalueRecordStore.orientation"
              :disabled="reportGlobalvalueRecordStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="原来值"
            prop="originalValue"
          >
            <el-input
              size="small"
              style='width: 200px'
              v-model="reportGlobalvalueRecordStore.originalValue"
              :disabled="reportGlobalvalueRecordStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="剩余值"
            prop="restValue"
          >
            <el-input
              size="small"
              style='width: 200px'
              v-model="reportGlobalvalueRecordStore.restValue"
              :disabled="reportGlobalvalueRecordStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户ID"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="reportGlobalvalueRecordStore.userId"-->
<!--              :disabled="reportGlobalvalueRecordStoreState == 'check'"-->
<!--            ></el-input>-->
              <GridSelect
                  style='width: 180px'
                  title='选择用户'
                  labelName='userName'
                  labelValue='id'
                  :value='reportGlobalvalueRecordStore.userId'
                  :limit='1'
                  size='small'
                  placeholder='请选择用户'
                  :disabled="reportGlobalvalueRecordStoreState == 'check'"
                  @getValue='getValue'
                  :columns="USER_code"
                  :searchs="USER_search"
                  dataListUrl='/mpp/user/findList'
                  entityBeanName='mppUser'
                  queryEntityUrl='/mpp/user/get'
              >
              </GridSelect>
          </el-form-item>
          <el-form-item
            label="门店ID"
            prop="storeId"
          >
            <el-input
              size="small"
              style='width: 200px'
              v-model="reportGlobalvalueRecordStore.storeId"
              :disabled="reportGlobalvalueRecordStoreState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="reportGlobalvalueRecordStoreState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelect,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetReportGlobalvalueRecordStoreList();
                    this.getReportGlobalvalueRecordStoreList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetReportGlobalvalueRecordStoreList();
                    this.getReportGlobalvalueRecordStoreList();
                    this.$emit('resetCheckState');
                }
            },
            //市
            'queryForm.provinceId'(id) {
                if (!id) {
                    return;
                }
                setTimeout(() => {
                    this.queryForm.cityId = '';
                    this.queryForm.areaId = '';
                    this.queryForm.streetId = '';
                    this.getAddress(2, id);
                }, 5);
            },
            //区
            'queryForm.cityId'(id) {
                if (!id) {
                    return;
                }
                setTimeout(() => {
                    this.queryForm.areaId = '';
                    this.queryForm.streetId = '';
                    this.getAddress(3, id);
                }, 10);
            },
            //社区
            'queryForm.areaId'(id) {
                if (!id) {
                    return;
                }
                setTimeout(() => {
                    this.queryForm.streetId = '';
                    this.getAddress(4, id);
                }, 15);
            },
        },
    data() {
            return {
                queryForm:{
                     valueType: '', //数值类型
                     value: '', //数值
                     orientation: '', //方向
                     originalValue: '', //原来值
                     restValue: '', //剩余值
                     userId: '', //用户ID
                     storeId: '', //门店ID
                    provinceId: '',
                    cityId: '',
                    areaId: '',
                    streetId: ''
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                reportGlobalvalueRecordStoreState: 'add',
                reportGlobalvalueRecordStoreStates: {
                    add: '新建发放记录',
                    check: '查看发放记录',
                    edit: '修改发放记录'
                },

                multipleSelection: [],
                reportGlobalvalueRecordStoreList: [],
                reportGlobalvalueRecordStore: {
                    id: '', //ID
                    valueType: '', //数值类型
                    value: '', //数值
                    orientation: '', //方向
                    originalValue: '', //原来值
                    restValue: '', //剩余值
                    userId: '', //用户ID
                    storeId: '', //门店ID
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    valueType: [{ required: true, message: '数值类型不能为空', trigger: 'blur' }],
                    value: [{ required: true, message: '数值不能为空', trigger: 'blur' }],
                    orientation: [{ required: true, message: '方向不能为空', trigger: 'blur' }],
                    originalValue: [{ required: true, message: '原来值不能为空', trigger: 'blur' }],
                    restValue: [{ required: true, message: '剩余值不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                    storeId: [{ required: true, message: '门店ID不能为空', trigger: 'blur' }],
                },
                globalvalueTypeEnumList: [],
                statusList: [],

                provinceIdList: [], //省信息
                cityIdList: [], //市信息
                areaIdList: [], //区信息
                streetIdList: [],
            };
        },
        created() {
            // this.getReportGlobalvalueRecordStoreList();
            this.getGlobalvalueTypeEnum()
            this.globalvalueOrientation()
            this.getAddress(1);
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            // 获取对应地址
            getAddress(type, id = null) {
                get('/mpp/utils/findAreaList', { areaType: type, pid: id }).then((res) => {
                    if (res.success) {
                        let array = [];
                        for (let listElement of res.list) {
                            listElement.id = String(listElement.id);
                            array.push(listElement);
                        }
                        if (type == 1) {
                            this.provinceIdList = array;
                        } else if (type == 2) {
                            this.cityIdList = array;
                        } else if (type == 3) {
                            this.areaIdList = array;
                        } else if (type == 4) {
                            this.streetIdList = array;
                        }
                    }
                });
            },
            globalvalueOrientation(){
                get("/mpp/utils/getEnum?enumType=globalvalue_orientation").then((res)=>{
                    if(res.success){
                        this.statusList = res.enumList
                    }
                })
            },
            returnValue(key){
                for (let i = 0; i < this.statusList.length; i++) {
                    if(this.statusList[i].key === key){
                        return this.statusList[i].value
                    }
                }
            },
            init(id){
                this.queryForm.valueType = id
                this.reportGlobalvalueRecordStore.valueType = id
                this.getReportGlobalvalueRecordStoreList();
            },
            getSearchValue(value) {
                this.queryForm.userId = value;
            },
            getValue(value) {
                this.reportGlobalvalueRecordStore.userId = value;
            },
            // 获取GlobalvalueTypeEnum
            getGlobalvalueTypeEnum(){
                get('/report/utils/getEnum',{
                    enumType: 'global_value_type_life_enum'
                }).then((res)=>{
                    if(res.success && res.code === 200){
                        this.globalvalueTypeEnumList = res.enumList
                    }
                })
            },

            // 计算computeGlobalvalue
            computeGlobalvalueType(type){
                for (let i = 0; i < this.globalvalueTypeEnumList.length; i++) {
                    if(this.globalvalueTypeEnumList[i].key === type){
                        return this.globalvalueTypeEnumList[i].value
                    }
                }
            },
            resetReportGlobalvalueRecordStoreList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.reportGlobalvalueRecordStoreList = [];
            },
            resetDialog() {
                this.reportGlobalvalueRecordStoreState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      valueType: this.queryForm.valueType, //数值类型
                      value: '', //数值
                      orientation: '', //方向
                      originalValue: '', //原来值
                      restValue: '', //剩余值
                      userId: '', //用户ID
                      storeId: '', //门店ID
                    provinceId: '',
                    cityId: '',
                    areaId: '',
                    streetId: ''
                };
                this.getReportGlobalvalueRecordStoreList();
            },
            closeDialog() {
                this.showDialog = false
                this.reportGlobalvalueRecordStore = {
                      id: '', //ID
                      valueType: this.reportGlobalvalueRecordStore.valueType, //数值类型
                      value: '', //数值
                      orientation: '', //方向
                      originalValue: '', //原来值
                      restValue: '', //剩余值
                      userId: '', //用户ID
                      storeId: '', //门店ID
                };
            },
            submitForm() {
                if (this.reportGlobalvalueRecordStoreState == 'add') {
                    this.$refs.reportGlobalvalueRecordStoreForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/report/globalvaluerecordlife/add`,{ ...this.reportGlobalvalueRecordStore }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetReportGlobalvalueRecordStoreList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.reportGlobalvalueRecordStoreState == 'edit') {
                    this.$refs.reportGlobalvalueRecordStoreForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/report/globalvaluerecordlife/edit`,{ ...this.reportGlobalvalueRecordStore }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetReportGlobalvalueRecordStoreList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addReportGlobalvalueRecordStore() {
                this.showDialog = true;
                this.reportGlobalvalueRecordStoreState = 'add';
            },
            checkReportGlobalvalueRecordStore(reportGlobalvalueRecordStoreId) {
                console.log(reportGlobalvalueRecordStoreId);
                this.currentReportGlobalvalueRecordStoreId = reportGlobalvalueRecordStoreId;

                this.getReportGlobalvalueRecordStoreById();
                this.showDialog = true;
                this.reportGlobalvalueRecordStoreState = 'check';
            },
            editReportGlobalvalueRecordStore(reportGlobalvalueRecordStoreId) {
                console.log('reportGlobalvalueRecordStore', reportGlobalvalueRecordStoreId);
                if (reportGlobalvalueRecordStoreId) {
                    this.currentReportGlobalvalueRecordStoreId = reportGlobalvalueRecordStoreId;
                    this.getReportGlobalvalueRecordStoreById();
                } else {
                    this.reportGlobalvalueRecordStore = { ...this.reportGlobalvalueRecordStore, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.reportGlobalvalueRecordStoreState = 'edit';
            },
            deleteReportGlobalvalueRecordStore(reportGlobalvalueRecordStoreId) {
                let ids = '';
                if (reportGlobalvalueRecordStoreId) {
                    ids = reportGlobalvalueRecordStoreId;
                } else {
                    ids = this.multipleSelection.map((reportGlobalvalueRecordStore) => reportGlobalvalueRecordStore.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/report/globalvaluerecordlife/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetReportGlobalvalueRecordStoreList();
                                this.getReportGlobalvalueRecordStoreList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshReportGlobalvalueRecordStoreList() {
                this.resetReportGlobalvalueRecordStoreList();
                this.getReportGlobalvalueRecordStoreList();
            },
            getReportGlobalvalueRecordStoreList(query = {}) {
                this.loading = true;
                get(`/report/globalvaluerecordlife/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.reportGlobalvalueRecordStoreList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getReportGlobalvalueRecordStoreById() {
                get(`/report/globalvaluerecordlife/get`,{ id: this.currentReportGlobalvalueRecordStoreId }).then((res) =>{
                    if(res.success){
                      this.reportGlobalvalueRecordStore = { ...this.reportGlobalvalueRecordStore, ...res.reportGlobalvalueRecordStore };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportReportGlobalvalueRecordStoreList() {
                //this.btnLoading = true;
                exprotExcel(`/report/globalvaluerecordlife/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/report/globalvaluerecordlife/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/report/globalvaluerecordlife/importData`,formData);
              this.refreshReportGlobalvalueRecordStoreList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getReportGlobalvalueRecordStoreList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getReportGlobalvalueRecordStoreList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>